import type { ConfigContextState } from 'app/common/ConfigContext';

import { METRICS_TO_TRACK } from './metrics.config';

const getMetricsSuffix = (config: ConfigContextState, _displayedTab?: Tab | null): string => {
  const metrics = METRICS_TO_TRACK.filter(metricKey => config[metricKey]).map(metricKey => {
    let value = config[metricKey];
    if (Array.isArray(value)) {
      value = value.join(',');
    }
    return `${metricKey}=${config[metricKey]}`;
  });

  // if we're working locally, there's no /v2
  const userParamIndex = import.meta.env.DEV ? 1 : 2;
  const userPathParam = `user_path_param=${location.pathname.split('/')[userParamIndex]}`;

  // if (displayedTab) {
  //   metrics.push(`displayed_tab=${displayedTab}`);
  // }

  // The customer slug is always sent: back-ratchet rejects unknown slugs, so
  // the widget must identify itself even when no metric flag is on.
  if (metrics.length) {
    return `?${metrics.join('&')}&${userPathParam}`;
  }
  return `?${userPathParam}`;
};

export { getMetricsSuffix };
